import Vue from 'vue'
import VideoPreview from './videoPreview.vue'

const MyVideoPreview = Vue.extend(VideoPreview)

VideoPreview.install = (Vue) => {
  return Vue.prototype.$VideoPreview = (options) => {
    let { url } = options
    let fileType = 1  // 1 视频 2 音频
    if(/\.(mp3|wav|aac|ogg|flac|m4a|wma|aif|aiff)$/i.test(url)) {
      fileType = 2
    }
    let instance = new MyVideoPreview({
      data: {
        url,
        fileType,
      },
    }).$mount()
  
    document.body.appendChild(instance.$el)

    return instance.init()
  }
}

export default VideoPreview